/**
 * @file planUtils.ts
 * @description Utility functions for handling editorial plan data. This file includes functions to manipulate and filter plan data.
 */

import { ContentDetails } from "../../types";

export const excludeLastEmptyRow = (
  data: ContentDetails[]
): ContentDetails[] => {
  return data.filter((item, index) => {
    if (index === data.length - 1) {
      // Only check keyword and relatedKeywords (website, contentType, clientInfo are now plan-level)
      return (
        item.keyword ||
        item.relatedKeywords.length ||
        item.peopleAlsoAsk?.length
      );
    }
    return true;
  });
};
